// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"132":"2cd0817f","245":"ac284484","561":"54cd802f","578":"9abb16db","752":"9abb16db","817":"9abb16db","873":"fc4b90c5","935":"9abb16db"}[chunkId] + ".css";
};